export default {
  init() {
    $(function () {
      const $article = $("main article");

      // it works if the header with content is the first element in the page
      const $hero = $article.children().first();

      if ($hero.hasClass("section-hero-with-content-box")) {
        const $box = $hero.find(".hero-with-content-box__box");
        $box.insertAfter($hero);

        $(window).on('resize', () => onResize());

        onResize();
        setTimeout(onResize, 1000);
      }
    });
  },
};

let onResize = () => {
  const $hero = $("main article .section-hero-with-content-box");
  const $box = $(
    "main article .section-hero-with-content-box + .hero-with-content-box__box"
  );
  const $heroInner = $hero.find(".hero-with-content-box__inner");

  $box.css("margin-top", -$box.outerHeight());

  if ( $('body').hasClass('cloud-native-detection-and-response') ) {
    $box.css("margin-top", -$box.outerHeight() + 65);
  }

  $hero.css("position", "fixed");
  $hero.css("top", 0);
  $hero.css("right", 0);
  $hero.css("left", 0);
  $hero.css("z-index", -1);
  $heroInner.css("padding-bottom", $box.outerHeight());

  $hero.parent().css("padding-top", $hero.outerHeight());
};



// WEBPACK FOOTER //
// ./scripts/routes/parallax-header.js